exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group[data-v-9f6f9b2c] {\n  margin-bottom: 20px;\n}\n.form-group label[data-v-9f6f9b2c] {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 8px;\n}\n.form-group input[type=text][data-v-9f6f9b2c],\n.form-group input[type=number][data-v-9f6f9b2c],\n.form-group input[type=tel][data-v-9f6f9b2c] {\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 14px;\n  width: 100%;\n}\n.gap-md[data-v-9f6f9b2c] {\n  gap: 16px;\n}", ""]);

// exports
